class UserGroupEntityAssignmentInput {
  entityIds = [];
  
  userGroupIds = [];

  constructor(entityIds) {
    this.entityIds = entityIds;
  }

  static fromObject(entityIds) {
    return new UserGroupEntityAssignmentInput(entityIds);
  }
}

export default UserGroupEntityAssignmentInput;
